import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { DataService } from 'app/shared/services/data/data.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent extends SubscriptionBaseComponent implements OnInit {

  faUser = faUser;

  logIn: any;
  title: string;

  isGeo = false;
  isConnect: boolean;

  constructor(
    public router: Router,
    private titleService: TitleService,
    private cdr: ChangeDetectorRef,
    private dataService: DataService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
  }

  iWantToGeoOrNot(): void {
    this.isGeo = !this.isGeo;
    this.dataService.isGeo.next(this.isGeo);
  }

  private initSub(): void {
    this.subscription
      .add(
        this.titleService.title.asObservable().subscribe(title => {
          this.title = title;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.logIn.asObservable().subscribe(logIn => {
          this.logIn = logIn;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.isConnect.asObservable().subscribe(isConnect => {
          this.isConnect = isConnect;
          this.cdr.detectChanges();

        })
      );
    // this.subscription.add(
    //   this.dataService.isGeo.asObservable().subscribe(geo => {
    //     this.isGeo = geo;
    //     this.cdr.detectChanges();

    //   })
    // );
  }
}
